import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import styles from './MyListEvents.module.scss';
import EventList from '../EventList';
import LeafletMap from '../LeafletMap';
import {
    removeSavedId,
    MY_LIST_KEY_EVENT_OCCURRENCES,
} from '../../utils/MyListStorage';

const MyListEvents = ({ items = [], showRemoveButtons }) => {
    const [eventArray, setEventArray] = useState([]);
    const [viewport, setViewport] = useState(null);

    useEffect(() => {
        setEventArray(items);
    }, [items]);

    const handleOnMarkerClick = (id) => {
        let activeEventsArray = [
            ...eventArray.map((item) =>
                item.id == id
                    ? { ...item, active: !item.active }
                    : { ...item, active: false }
            ),
        ];
        setEventArray(activeEventsArray);
    };

    const handleEntryClick = (id) => {
        const { location } = eventArray?.find((event) => event.id === id);

        let activeEventsArray = [
            ...eventArray.map((item) =>
                item.id == id
                    ? { ...item, active: !item.active }
                    : { ...item, active: false }
            ),
        ];
        setEventArray(activeEventsArray);

        if (location) {
            setViewport({
                center: [location.latitude, location.longitude],
                zoom: 15,
            });
        }
    };

    const removeItemsFromList = (id) => {
        removeSavedId(MY_LIST_KEY_EVENT_OCCURRENCES, id);
        let listEvent = [...eventArray.filter((event) => event.id !== id)];
        setEventArray(listEvent);
    };

    return (
        <>
            {items && items.length > 0 && (
                <div className={styles['MyListEvents']}>
                    <section
                        className={
                            styles['MyListEvents__Events'] +
                            ' ' +
                            styles['MyListEvents__Events--HalfGrid']
                        }>
                        <div
                            className={
                                styles['MyListEvents__EventListWrapper']
                            }>
                            <EventList
                                events={eventArray}
                                isMyList
                                showRemoveButtons={showRemoveButtons}
                                onCardClickMap={handleEntryClick}
                                removeItemsFromList={removeItemsFromList}
                                onClick={handleEntryClick}
                            />
                        </div>
                    </section>
                    <section className={styles['MyListEvents__MapWrapper']}>
                        <LeafletMap
                            onMarkerClick={handleOnMarkerClick}
                            pins={eventArray}
                            showMarkers={true}
                            labels={['All']}
                            viewport={viewport}
                            mapStyle={'none'}
                        />
                    </section>
                </div>
            )}
        </>
    );
};

MyListEvents.propTypes = {
    items: PropTypes.array,
};

export default MyListEvents;
